import gql from "graphql-tag";

export const EDIT_RESOURCES_ON_TRUCKING_DATAS = gql`
  mutation editResourceOnTruckingDatas($where: UpdateResourceOnTruckingDatasInput!) {
    editResourceOnTruckingDatas(where: $where)
  }
`;